// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"116":"84c570b6","610":"d299642b"}[chunkId] + ".css";
};